<template>
    <svg width="245" height="245" viewBox="0 0 245 245" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M202.735 30.5067C181.224 11.5254 152.976 0.00137714 122.032 0.00137714C91.0886 0.00137714 62.8402 11.5254 41.3292 30.5067H202.735Z"
            fill="#DE2150" />
        <path
            d="M3.84375 152.539H240.22C242.729 142.788 244.064 132.566 244.064 122.034H0C0 132.566 1.33437 142.788 3.84375 152.539Z"
            fill="#FAB450" />
        <path
            d="M41.3151 213.548H202.749C212.633 204.823 221.096 194.527 227.739 183.043H16.326C22.9683 194.527 31.4307 204.823 41.3151 213.548Z"
            fill="#318797" />
        <path
            d="M41.3151 213.548C62.5959 232.332 90.4745 243.806 121.033 244.053H123.031C153.589 243.806 181.468 232.332 202.749 213.548H41.3151Z"
            fill="#1A3D5D" />
        <path
            d="M227.739 183.043C233.2 173.601 237.435 163.361 240.22 152.539H3.84375C6.62918 163.361 10.8646 173.601 16.326 183.043H227.739Z"
            fill="#53C4AB" />
        <path
            d="M3.8474 91.516C1.33697 101.265 0.00104167 111.487 0 122.021H244.064C244.063 111.487 242.727 101.265 240.217 91.516H3.8474Z"
            fill="#F57D33" />
        <path
            d="M3.84741 91.516H240.217C237.431 80.6934 233.193 70.4534 227.731 61.0107H16.3333C10.8709 70.4534 6.63387 80.6934 3.84741 91.516Z"
            fill="#F25938" />
        <path
            d="M16.3333 61.0107H227.731C221.087 49.5267 212.621 39.2307 202.735 30.5067H41.3292C31.4426 39.2307 22.9781 49.5267 16.3333 61.0107Z"
            fill="#F03B45" />
        <path
            d="M40.2016 109.649C40.2016 104.835 36.2984 100.931 31.4828 100.931C26.6677 100.931 22.764 104.835 22.764 109.649V156.129C22.764 160.944 26.6677 164.848 31.4828 164.848C36.2984 164.848 40.2016 160.944 40.2016 156.129V109.649Z"
            fill="white" />
        <path
            d="M76.4151 66.0854C76.4151 61.2694 72.512 57.3667 67.6964 57.3667C62.8812 57.3667 58.9776 61.2694 58.9776 66.0854V153.249C58.9776 158.064 62.8812 161.967 67.6964 161.967C72.512 161.967 76.4151 158.064 76.4151 153.249V66.0854Z"
            fill="white" />
        <path
            d="M112.643 134.191C112.643 129.375 108.74 125.471 103.925 125.471C99.1088 125.471 95.2052 129.375 95.2052 134.191V193.918C95.2052 198.734 99.1088 202.637 103.925 202.637C108.74 202.637 112.643 198.734 112.643 193.918V134.191Z"
            fill="white" />
        <path
            d="M148.859 115.403C148.859 110.588 144.955 106.684 140.14 106.684C135.325 106.684 131.421 110.588 131.421 115.403V213.283C131.421 218.097 135.325 222.001 140.14 222.001C144.955 222.001 148.859 218.097 148.859 213.283V115.403Z"
            fill="white" />
        <path
            d="M185.075 45.7347C185.075 40.92 181.171 37.016 176.356 37.016C171.54 37.016 167.637 40.92 167.637 45.7347V150.323C167.637 155.139 171.54 159.041 176.356 159.041C181.171 159.041 185.075 155.139 185.075 150.323V45.7347Z"
            fill="white" />
        <path
            d="M221.285 112.569C221.285 107.753 217.383 103.851 212.567 103.851C207.752 103.851 203.848 107.753 203.848 112.569V156.151C203.848 160.965 207.752 164.869 212.567 164.869C217.383 164.869 221.285 160.965 221.285 156.151V112.569Z"
            fill="white" />
        <path
            d="M122.117 97.284C142.075 97.284 158.247 81.1133 158.247 61.1547C158.247 41.196 142.075 25.0253 122.117 25.0253C102.158 25.0253 85.9875 41.196 85.9875 61.1547C85.9875 81.1133 102.158 97.284 122.117 97.284Z"
            fill="white" />
    </svg>
</template>
